import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SuccessGate } from '../services/success-gate.service';

/** `/success` is only reachable after the customer confirmed on the code page. */
export const successGuard: CanActivateFn = () =>
  inject(SuccessGate).isOpen() ? true : inject(Router).createUrlTree(['/']);
